import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    displayCaseType: true,
    overviewFilterText: true,
    overviewFilterProductTypes: ['ACCOUNTS', 'CARDS', 'INSURANCES', 'BUILDINGS'],
};
